import React, { useState } from "react";

const TagInput = ({ label, formikProps, name, placeholder = "Enter value...", disabled = false }) => {
    const [inputValue, setInputValue] = useState("");
    const tags = formikProps.values[name] || [];

    const handleKeyDown = (e) => {
        if (disabled) return;

        if ((e.key === "Enter" || e.key === ",") && inputValue.trim() !== "") {
            e.preventDefault();
            if (!tags.includes(inputValue.trim())) {
                const newTags = [...tags, inputValue.trim()];
                formikProps.setFieldValue(name, newTags);
            }
            setInputValue("");
        } else if (e.key === "Backspace" && inputValue === "") {
            const newTags = tags.slice(0, -1);
            formikProps.setFieldValue(name, newTags);
        }
    };

    const removeTag = (index) => {
        if (disabled) return;
        const newTags = tags.filter((_, i) => i !== index);
        formikProps.setFieldValue(name, newTags);
    };

    return (
        <div className="w-full">
            {label && <label className="mb-1 block font-medium text-sm">{label}</label>}
            <div
                className={`flex items-center flex-wrap gap-1 border rounded px-3 min-h-[40px] text-sm 
                    ${disabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
            >
                {tags.map((tag, index) => (
                    <div
                        key={index}
                        className="flex items-center bg-gray-200 px-2 py-[2px] rounded-full text-sm"
                    >
                        {tag}
                        {!disabled && (
                            <button
                                onClick={() => removeTag(index)}
                                className="ml-1 text-red-500 hover:text-red-700"
                            >
                                &times;
                            </button>
                        )}
                    </div>
                ))}
                
                <input
                    className="outline-none border-none flex-1 bg-transparent text-sm placeholder:text-gray-400 disabled:cursor-not-allowed"
                    value={inputValue}
                    placeholder={tags.length === 0 ? placeholder : ""}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    disabled={disabled}
                />

            </div>
        </div>
    );
};

export default TagInput;
